import { useContext } from 'react';
import 'react-awesome-lightbox/build/style.css';
import { ImageContext } from '../../../context/ImageContext';

import { ViewsAndLayoutsListItemWrapper, EditTitle, EditImage } from './styles';

const ViewsAndLayoutsEditItem = ({ imageId, imageIndex }) => {
  const { idCardImages, setIdCardImages, onSuccessImageUpload, onSuccessImageRemove, shouldSendDeleteImageReq } =
    useContext(ImageContext);

  const handleImageTitleChange = (event) => {
    const updatedImages = [...idCardImages];
    updatedImages[imageIndex].legend = event.target.value;
    setIdCardImages(updatedImages);
  };
  return (
    <ViewsAndLayoutsListItemWrapper>
      <EditImage
        imageId={imageId}
        imageArrIndex={imageIndex}
        onImageUpload={onSuccessImageUpload}
        onImageRemove={onSuccessImageRemove}
        shouldSendDeleteImageReq={shouldSendDeleteImageReq}
      />

      <EditTitle
        value={idCardImages[imageIndex].legend}
        name={'imageTitle'}
        placeholder='Label / Title'
        onChange={handleImageTitleChange}
        type='text'
      />
    </ViewsAndLayoutsListItemWrapper>
  );
};

export default ViewsAndLayoutsEditItem;
